const CAROUSEL_DEFAULT_OPTS = (
    {autoWidth, } = {
        autoWidth: false
    }
) => {
    return {
        autoWidth,
        gap: 20,
        pagination: false,
        breakpoints: {
            500: {
                autoWidth: false,
                perPage: 1,
                gap: 10,
            }
        }
    };
};

const CAROUSEL_INSIGHTS_OPTS = () => {
    return {
        perPage: 2,
        gap: 20,
        pagination: false,
        breakpoints: {
            500: {
                perPage: 1,
                gap: 10,
            }
        }
    };
};

const CAROUSEL_MIN_OPTS = () => {
    return {
        perPage: 1,
        pagination: false,
        type  : 'fade'
    };
};

export {CAROUSEL_DEFAULT_OPTS, CAROUSEL_INSIGHTS_OPTS, CAROUSEL_MIN_OPTS};
